export default "/images/vendor/@coreui/icons/svg/flag/cif-gh.svg?9aa5869e7aba1a7d7b9a1ed6d9b232c3";